import { useContext, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { EViews } from "./typings";
import ClassificationDefault from "../ClassificationDefault";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import workspaceService from "api/workspaceService";
import { IWorkspace } from "dto/IWorkspace";
import { getPrivilages } from "utils/getPrivilages";
import { AbilityContext, Can } from "contexts/AbilityContext";
import { useTranslation } from "react-i18next";

const ClassificationTab = () => {
  const { t } = useTranslation();
  const { data: workspaceData } = workspaceService.useGetWorkspace(
    getWorkspaceId() ?? "",
  );

  const workspace: IWorkspace = useMemo(
    () => (workspaceData?.data as IWorkspace) ?? [],
    [workspaceData],
  );

  const workspaceMembers = useMemo(() => workspace?.Members ?? [], [workspace]);
  const workspaceRoles = useMemo(() => workspace?.Roles ?? [], [workspace]);

  const me = workspaceMembers.find((membership) => membership.IsMe === true);
  const meRole = workspaceRoles.find((role) => role.Id === me?.RoleId);
  const myPrivilages = getPrivilages(meRole);

  const ability = useContext(AbilityContext);
  const [actualView, setActualView] = useState<EViews>(
    ability.can("accessModule", "cases")
      ? EViews.CASES
      : EViews.PACKAGES_INCOMING,
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.menu}>
        <Can I="accessModule" an="cases">
          <div
            onClick={() => setActualView(EViews.CASES)}
            className={`${styles.box}  ${
              actualView === EViews.CASES && styles.activeText
            }`}
          >
            {t("sidebar.cases")}
          </div>
        </Can>
        <Can I="accessModule" an="tasks">
          <div
            onClick={() => setActualView(EViews.ACTIONS)}
            className={`${styles.box}  ${
              actualView === EViews.ACTIONS && styles.activeText
            }`}
          >
            {t("menu.tasks")}
          </div>

          <div
            onClick={() => setActualView(EViews.EVENTS)}
            className={`${styles.box}  ${
              actualView === EViews.EVENTS && styles.activeText
            }`}
          >
            {t("actions.events")}
          </div>
        </Can>

        <Can I="accessModule" an="drive">
          <div
            onClick={() => setActualView(EViews.LETTERS)}
            className={`${styles.box}  ${
              actualView === EViews.LETTERS && styles.activeText
            }`}
          >
            {t("settings.filesAndLinks")}
          </div>
        </Can>
        <div
          onClick={() => setActualView(EViews.PACKAGES_INCOMING)}
          className={`${styles.box}  ${
            actualView === EViews.PACKAGES_INCOMING && styles.activeText
          }`}
        >
          {t("packages.title")}
        </div>
        {/* <div
          onClick={() => setActualView(EViews.PACKAGES_OUTCOMING)}
          className={`${styles.box}  ${
            actualView === EViews.PACKAGES_OUTCOMING && styles.activeText
          }`}
        >
          Przesyłki wychodzące
        </div> */}
        <Can I="accessModule" an="word">
          <div
            onClick={() => setActualView(EViews.TEMPLATES)}
            className={`${styles.box}  ${
              actualView === EViews.TEMPLATES && styles.activeText
            }`}
          >
            {t("settings.templates")}
          </div>
        </Can>

        <Can I="accessModule" an="drive">
          <div
            onClick={() => setActualView(EViews.FOLDERS)}
            className={`${styles.box}  ${
              actualView === EViews.FOLDERS && styles.activeText
            }`}
          >
            {t("settings.foldersInDossier")}
          </div>
        </Can>
      </div>

      <ClassificationDefault myPrivilages={myPrivilages} type={actualView} />
    </div>
  );
};

export default ClassificationTab;
